/* DecantGems scent finder: a stepper and a live result count on top of a plain GET form
   (sections/dg-finder.liquid). Without this file the form shows every question and is sent as it is.
   The count, the count per answer and the three first matches come from the same section, rendered on the
   collection URL with the chosen filters (Section Rendering API): no other requests. */
(function () {
  'use strict';

  var html = document.documentElement;
  var root = document.querySelector('[data-nf]');
  if (!root || root.hasAttribute('data-nf-ready')) return;
  var form = root.querySelector('[data-nf-form]');
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-nf-step]'));
  var panel = root.querySelector('[data-nf-result]');
  if (!form || !steps.length || !panel || !window.fetch || !window.URLSearchParams) {
    html.classList.remove('dg-finder-js');
    return;
  }
  root.setAttribute('data-nf-ready', '');

  var T = {};
  try {
    T = JSON.parse(root.querySelector('[data-nf-strings]').textContent);
  } catch (e) {}

  var total = steps.length;
  var action = (form.getAttribute('action') || '').split('#');
  var base = action[0];
  var hash = action[1] ? '#' + action[1] : '';
  var sectionId = root.getAttribute('data-nf-section') || 'dg-finder';
  var segs = Array.prototype.slice.call(root.querySelectorAll('.dg-finder__seg'));
  var live = root.querySelector('[data-nf-live]');
  var countEl = root.querySelector('[data-nf-count]');
  var backBtn = root.querySelector('[data-nf-back]');
  var nextBtn = root.querySelector('[data-nf-next]');
  var zero = root.querySelector('[data-nf-zero]');
  var title = panel.querySelector('[data-nf-title]');
  var answers = panel.querySelector('[data-nf-answers]');
  var link = panel.querySelector('[data-nf-link]');
  var panelDrop = panel.querySelector('[data-nf-drop]');
  var first = panel.querySelector('[data-nf-first]');
  var cards = panel.querySelector('[data-nf-cards]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var cur = 0; /* 0 … total - 1 = a question, total = the result */
  var seen = 0;
  var done = false;
  var data = null;
  var cache = {};
  var seq = 0;
  var timer = null;
  var pointerAt = 0;
  var STORE = 'dg-finder';

  function fill(text, map) {
    return String(text || '').replace(/\{(\w+)\}/g, function (m, k) {
      return k in map ? map[k] : m;
    });
  }
  function named(step) {
    return Array.prototype.slice.call(step.querySelectorAll('input[name]'));
  }
  function chosen(step) {
    return named(step).filter(function (i) {
      return i.checked && i.value;
    });
  }
  function anyBox(step) {
    return step.querySelector('[data-nf-any]');
  }
  function query() {
    var p = new URLSearchParams();
    steps.forEach(function (step) {
      chosen(step).forEach(function (i) {
        p.append(i.name, i.value);
      });
    });
    return p.toString();
  }
  /* The answers as a tag path: /collections/all-samples/audience-men+season-winter. all-samples has more than
     5,000 products, so Shopify ignores filter.* parameters there (phone-nl-21); tag paths do work. The product
     tags are group:key (audience:men), whose handle is group-key; Shopify wants the tags in alphabetical order. */
  function tagPath() {
    var tags = [];
    steps.forEach(function (step) {
      chosen(step).forEach(function (i) {
        var t = i.getAttribute('data-nf-tag');
        if (t) tags.push(t);
      });
    });
    tags.sort();
    return tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '';
  }
  function num(n) {
    try {
      return new Intl.NumberFormat(html.lang || undefined).format(n);
    } catch (e) {
      return String(n);
    }
  }
  function clearStep(step) {
    named(step).forEach(function (i) {
      i.checked = i.type === 'radio' && !i.value;
    });
    var box = anyBox(step);
    if (box) box.checked = true;
  }

  /* ---------- data ---------- */
  function load(qs) {
    if (cache[qs]) return Promise.resolve(cache[qs]);
    var url = base + qs + '?section_id=' + encodeURIComponent(sectionId);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var d = JSON.parse(doc.querySelector('[data-nf-data]').textContent);
        var list = doc.querySelector('[data-nf-cards]');
        d.cards = list ? list.innerHTML : '';
        d.values = d.values || {};
        cache[qs] = d;
        return d;
      });
  }
  function refresh() {
    var qs = tagPath();
    var id = ++seq;
    link.href = base + qs + hash;
    root.classList.add('is-busy');
    load(qs)
      .then(function (d) {
        if (id !== seq) return;
        data = d;
      })
      .catch(function () {
        if (id !== seq) return;
        data = null;
      })
      .then(function () {
        if (id !== seq) return;
        root.classList.remove('is-busy');
        render();
      });
  }

  /* ---------- drawing ---------- */
  function render() {
    var n = data ? data.count : null;

    if (countEl) {
      countEl.textContent = n === null ? '' : n === 0 ? T.zero : fill(n === 1 ? T.one : T.other, { n: num(n) });
    }
    if (zero) zero.hidden = !(n === 0 && cur < total);

    steps.forEach(function (step, si) {
      var max = parseInt(step.getAttribute('data-nf-max'), 10) || 1;
      var picked = chosen(step);
      var full = max > 1 && picked.length >= max;
      var later = steps.some(function (s, k) {
        return k > si && chosen(s).length > 0;
      });
      var list = named(step).filter(function (i) {
        return i.value;
      });
      /* the filter of this question is known when at least one of its values came back */
      var known = !!data && list.some(function (i) {
        return i.value in data.values;
      });
      var grey = false;

      list.forEach(function (i) {
        var opt = i.closest('.dg-finder__opt');
        var wrap = opt.querySelector('.dg-finder__n');
        var c = known ? data.values[i.value] : undefined;
        var empty = known && !c && !i.checked;
        /* a value no perfume of the collection has is not offered at all */
        opt.hidden = known && c === undefined && !i.checked;
        if (wrap) {
          wrap.hidden = !(known && c !== undefined);
          if (!wrap.hidden) wrap.querySelector('[data-nf-n]').textContent = c;
        }
        opt.classList.toggle('is-empty', empty);
        /* an answer without a match is closed while only earlier answers stand in its way;
           with later answers in play it stays open, the "remove my last answer" button then helps */
        var blocked = empty && !later;
        if (blocked) grey = true;
        i.disabled = blocked || (full && !i.checked);
      });

      var box = anyBox(step);
      if (box) box.checked = picked.length === 0;
      var note = step.querySelector('[data-nf-grey]');
      if (note) note.hidden = !grey;
      var maxNote = step.querySelector('[data-nf-maxnote]');
      if (maxNote) maxNote.hidden = !full;
    });

    /* result panel */
    title.textContent = n === null ? T.resultPlain : n === 0 ? T.resultZero : fill(n === 1 ? T.resultOne : T.resultOther, { n: num(n) });
    if (n === 0) link.setAttribute('aria-disabled', 'true');
    else link.removeAttribute('aria-disabled');
    link.tabIndex = n === 0 ? -1 : 0;
    panelDrop.hidden = n !== 0;
    if (cur === total && live && live.textContent && live.textContent !== title.textContent) live.textContent = title.textContent;
    if (data && data.cards && n > 0) {
      if (cards.getAttribute('data-nf-for') !== link.href) {
        cards.innerHTML = data.cards;
        cards.setAttribute('data-nf-for', link.href);
      }
      first.hidden = false;
    } else {
      first.hidden = true;
    }
    drawAnswers();
  }

  function drawAnswers() {
    answers.textContent = '';
    steps.forEach(function (step, k) {
      var picked = chosen(step).map(function (i) {
        return i.getAttribute('data-nf-label');
      });
      var fallback = step.querySelector('.dg-finder__opt--any input');
      var value = picked.length ? picked.join(' + ') : fallback ? fallback.getAttribute('data-nf-label') : '';
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-nf-go', k);
      var name = document.createElement('span');
      name.className = 'dg-finder__answer-k';
      name.textContent = step.getAttribute('data-nf-name') || '';
      var val = document.createElement('span');
      val.className = 'dg-finder__answer-v';
      val.textContent = value;
      var hint = document.createElement('span');
      hint.className = 'dg-vh';
      hint.textContent = ', ' + (T.change || '');
      b.appendChild(name);
      b.appendChild(document.createTextNode(' '));
      b.appendChild(val);
      b.appendChild(hint);
      li.appendChild(b);
      answers.appendChild(li);
    });
  }

  function chrome() {
    segs.forEach(function (seg, k) {
      seg.disabled = !(done || k <= seen) || k === cur;
      seg.classList.toggle('is-done', k < cur || cur === total);
      if (k === cur) seg.setAttribute('aria-current', 'step');
      else seg.removeAttribute('aria-current');
    });
    backBtn.hidden = cur === 0;
    nextBtn.hidden = cur === total;
    nextBtn.textContent = cur === total - 1 || done ? T.finish : T.next;
    root.setAttribute('data-nf-at', cur === total ? 'result' : String(cur + 1));
    if (zero) zero.hidden = !(data && data.count === 0 && cur < total);
  }

  /* ---------- moving ---------- */
  function save() {
    try {
      var a = [];
      steps.forEach(function (step) {
        chosen(step).forEach(function (i) {
          a.push([i.name, i.value]);
        });
      });
      sessionStorage.setItem(STORE, JSON.stringify({ a: a, seen: seen, done: done }));
    } catch (e) {}
  }
  function stickyHeader() {
    var h = document.querySelector('.header-section') || document.querySelector('#header-group');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    return pos === 'sticky' || pos === 'fixed' ? h.getBoundingClientRect().height : 0;
  }
  function go(i, opts) {
    opts = opts || {};
    i = Math.max(0, Math.min(total, i));
    clearTimeout(timer);
    var moved = i !== cur;
    if (moved || opts.force) root.setAttribute('data-nf-dir', i < cur ? 'back' : 'fwd');
    cur = i;
    if (i > seen) seen = i;
    if (i === total) done = true;
    steps.forEach(function (step, k) {
      step.classList.toggle('is-current', k === i);
    });
    panel.hidden = i !== total;
    panel.classList.toggle('is-current', i === total);
    chrome();

    var head = (i === total ? panel : steps[i]).querySelector('.dg-finder__q');
    if (live && opts.announce !== false) {
      live.textContent = i === total ? title.textContent : fill(T.live, { n: i + 1, t: total, q: head ? head.textContent : '' });
    }
    if (opts.push !== false && moved) {
      try {
        history.pushState(Object.assign({}, history.state, { nf: i }), '');
      } catch (e) {}
    }
    if (opts.focus !== false && head) {
      try {
        head.focus({ preventScroll: true });
      } catch (e) {
        head.focus();
      }
    }
    if (opts.scroll !== false) {
      var top = form.getBoundingClientRect().top;
      var off = stickyHeader();
      var bar = nextBtn.parentNode.getBoundingClientRect();
      /* phones: every question starts at the top of the screen; wider screens only move when the top of the
         form or the buttons under the question are out of view */
      var small = window.matchMedia && window.matchMedia('(max-width: 599px)').matches;
      var gap = small ? 2 : 12;
      var away = small ? Math.abs(top - off - gap) > 24 : top < off || (bar.bottom > window.innerHeight && top - off - gap > 24);
      if (away) {
        form.style.scrollMarginTop = Math.round(off + gap) + 'px';
        form.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    save();
  }
  function forward() {
    go(done ? total : cur + 1);
  }
  function dropLast() {
    for (var k = total - 1; k >= 0; k--) {
      if (chosen(steps[k]).length) {
        clearStep(steps[k]);
        break;
      }
    }
    render();
    refresh();
    save();
  }

  /* ---------- events ---------- */
  form.addEventListener(
    'pointerdown',
    function () {
      pointerAt = Date.now();
    },
    true
  );

  form.addEventListener(
    'keydown',
    function () {
      pointerAt = 0;
    },
    true
  );

  form.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('input')) return;
    var step = input.closest('[data-nf-step]');
    if (!step) return;
    if (input.hasAttribute('data-nf-any')) {
      clearStep(step);
    } else if (input.type === 'checkbox') {
      var max = parseInt(step.getAttribute('data-nf-max'), 10) || 1;
      if (chosen(step).length > max) input.checked = false;
    }
    render();
    refresh();
    save();
  });

  /* a tap or click on a single-choice answer moves on by itself; arrow keys and space do not */
  form.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.matches) return;
    if (t.matches('input[type="radio"]')) {
      if (Date.now() - pointerAt > 1200) return;
      if (steps.indexOf(t.closest('[data-nf-step]')) !== cur) return;
      clearTimeout(timer);
      timer = setTimeout(forward, reduce ? 150 : 420);
      return;
    }
    var goBtn = t.closest('[data-nf-go]');
    if (goBtn) {
      go(parseInt(goBtn.getAttribute('data-nf-go'), 10));
      return;
    }
    if (t.closest('[data-nf-next]')) {
      forward();
    } else if (t.closest('[data-nf-back]')) {
      go(cur - 1);
    } else if (t.closest('[data-nf-drop]')) {
      dropLast();
    } else if (t.closest('[data-nf-restart]')) {
      form.reset();
      steps.forEach(clearStep);
      done = false;
      seen = 0;
      data = null;
      render();
      refresh();
      go(0, { force: true });
    }
  });

  /* Enter in a question moves on; on the result it opens the listing */
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (cur === total) {
      if (link.getAttribute('aria-disabled') !== 'true') window.location.href = link.href;
    } else {
      forward();
    }
  });

  window.addEventListener('popstate', function (event) {
    var s = event.state;
    go(s && typeof s.nf === 'number' ? s.nf : 0, { push: false });
  });

  /* phones: keep the sticky bar above Shopify's cookie banner while that is open */
  function lift() {
    var b = document.getElementById('shopify-pc__banner');
    var h = 0;
    if (b && getComputedStyle(b).display !== 'none') h = Math.round(b.getBoundingClientRect().height);
    root.style.setProperty('--nf-lift', h + 'px');
    return b;
  }
  (function watchBanner() {
    var seenBanner = lift();
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () {
      var b = lift();
      if (b && b !== seenBanner) {
        seenBanner = b;
        mo.observe(b, { attributes: true, attributeFilter: ['style', 'class'] });
      }
    });
    mo.observe(document.body, { childList: true });
    if (seenBanner) mo.observe(seenBanner, { attributes: true, attributeFilter: ['style', 'class'] });
    window.addEventListener('resize', lift);
  })();

  /* ---------- start ---------- */
  (function start() {
    var at = history.state && typeof history.state.nf === 'number' ? history.state.nf : null;
    var saved = null;
    if (at !== null) {
      try {
        saved = JSON.parse(sessionStorage.getItem(STORE) || 'null');
      } catch (e) {}
    }
    form.reset();
    steps.forEach(clearStep);
    if (saved && saved.a) {
      /* back from the listing, or a reload: the answers and the place return */
      saved.a.forEach(function (pair) {
        steps.forEach(function (step) {
          named(step).forEach(function (i) {
            if (i.name === pair[0] && i.value === pair[1]) {
              i.checked = true;
              var box = anyBox(step);
              if (box) box.checked = false;
            }
          });
        });
      });
      seen = Math.min(total, saved.seen || 0);
      done = !!saved.done;
    } else {
      at = 0;
    }
    try {
      history.replaceState(Object.assign({}, history.state, { nf: at }), '');
    } catch (e) {}
    cur = -1;
    go(at, { push: false, focus: false, scroll: false, announce: false });
    root.removeAttribute('data-nf-dir');
    render();
    refresh();
  })();

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      chrome();
      render();
    }
  });
})();
